import React from "react";
import { Link } from "react-router-dom";

function Latestnews() {
  const data = [
    {
      id: 1,
      img: "assets/images/blog/blog-3-1.jpg",
      name: "Rise Of Design Thinking Problems Strategy Development",
      subname: "Life insurance",
    },
    {
      id: 2,
      img: "assets/images/blog/blog-3-1.jpg",
      name: "Spinning Up Multiple WordPress Sites Locally With DevKinsta",
      subname: "car insurance",
    },
    {
      id: 3,
      img: "assets/images/blog/blog-3-1.jpg",
      name: "Rise Of Design Thinking Problems Strategy Development",
      subname: "Life insurance",
    },
  ];
  return (
    <>
      <section className="blog-three">
        <div className="container">
          <div className="portfolio-one__top">
            <div className="sec-title text-start">
              <p className="sec-title__tagline">get every updates</p>

              <h3 className="sec-title__title">
                Read our latest news &amp; blog
              </h3>
            </div>

            <div className="portfolio-one__btns">
              <Link to="/blog" className="thm-btn thm-btn--two blog-three__btn">
                <span>
                  View All News
                  <i className="far fa-arrow-right" />
                </span>
              </Link>
            </div>
          </div>

          <div className="row gutter-y-30">
            {data.map((item) => (
              <div className="col-md-12 col-lg-4" key={item.id}>
                <div className="blog-card-three">
                  <div className="blog-card-three__image">
                    <img src={item.img} />
                  </div>

                  <ul className="blog-card-three__meta list-unstyled">
                    <li>
                      <Link to="#">September 25. 2022</Link>
                    </li>
                    <li>
                      <Link to="#">By Admin</Link>
                    </li>
                  </ul>

                  <div className="blog-card-three__category">
                    <Link to="#">{item.subname}</Link>
                  </div>

                  <h3 className="blog-card-three__title">
                    <Link to="/blogdetails">{item.name}</Link>
                  </h3>

                  <div className="blog-card-three__btns">
                    <Link
                      to="/blogdetails"
                      className="thm-btn blog-card-three__btn"
                    >
                      <span>
                        Read More
                        <i className="far fa-arrow-right" />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Latestnews;
